import React, { useEffect, useState } from 'react';
import { ImCancelCircle } from 'react-icons/im';
import Modal from 'react-modal';
import SalesOrderDetailsComponent from './SalesOrderDetailsComponent';
import { authAxiosWithBearer, baseURL } from '../baseURL';
import ShowToast from './ShowToast';

function InvoiceDetailsModal({ isOpen, onClose, invoiceNo }) {
  const [invoiceDetailsData, setInvoiceDetailsData] = useState(null);

  useEffect(() => {
    const fetchInvoiceDetailsData = async () => {
      try {
        const response = await authAxiosWithBearer.get(`${baseURL}/inventory/api/sales-information-details-with-invoice/${invoiceNo}/`);
        setInvoiceDetailsData(response.data);
      } catch (error) {
        console.log(error);
        if (invoiceNo && error.response && error.response.status === 404) {
          ShowToast('error', 'Data not found');
        }
        }
    };

    if (isOpen) {
      fetchInvoiceDetailsData();
    }
  }, [isOpen, invoiceNo]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Purchased Details Modal"
      className="modal"
      overlayClassName="overlay"
    >
      <div className='mb-2 w-[360px] md:w-[650px] lg:w-[1200px] overflow-y-auto h-[500px]'>
        <div className='modal-title flex justify-between bg-[#fff] text-[#EB5757] text-[18px] px-3 py-2 rounded-[5px] mb-10 shadow fixed top-0 left-0 right-0 z-50'>
          <h1 className='font-semibold'>Purchased Details </h1>
          <button className='text-[#000]' onClick={onClose}><ImCancelCircle /></button>
        </div>
        
        <SalesOrderDetailsComponent salesData={invoiceDetailsData} />
      </div>
    </Modal>
  );
}

export default InvoiceDetailsModal;